<template>
    <section class="newsletter">
      <div class="container">
        <div class="newsletter-content">
          <h2>Subscribe to Our Newsletter</h2>
          <p>Get the latest updates on new products and upcoming sales</p>
          <form class="newsletter-form" @submit.prevent="subscribe">
            <input type="email" v-model="email" placeholder="Your email address" required>
            <button type="submit" class="btn-primary">Subscribe</button>
          </form>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'NewsletterSection',
    data() {
      return {
        email: ''
      }
    },
    methods: {
      subscribe() {
        // Here you would typically send the email to your backend
        alert(`Thank you for subscribing with ${this.email}!`)
        this.email = ''
      }
    }
  }
  </script>
  
  <style scoped>
  .newsletter {
    padding: 60px 0;
    background-color: var(--primary-color);
    color: var(--white);
  }
  
  .newsletter-content {
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
  }
  
  .newsletter h2 {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  
  .newsletter p {
    margin-bottom: 30px;
  }
  
  .newsletter-form {
    display: flex;
    gap: 10px;
  }
  
  .newsletter-form input {
    flex: 1;
    padding: 12px 15px;
    border: none;
    border-radius: var(--border-radius);
    outline: none;
  }
  
  .newsletter-form .btn-primary{
    border: 1px solid white;
  }

  @media (max-width: 768px) {
    .newsletter-form {
      flex-direction: column;
    }
  }
  </style>